import React from "react";
import { getContainerClass } from "../../components/navigation/navigation";
import Cover from "../../components/cover/cover";
import AddFacility from "../../components/facilities/addfacility/addfacility";
import Header from "../../components/header/header";
import { useLocation } from "react-router-dom";

const ViewFacilityPage = () => {
  const location = useLocation();
  const breadcrumb = ["Home", "Facilities", "View Facility"];

  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        <Header />
        <Cover breadcrumb={breadcrumb} page="viewfacility" />
        <div className="facility-content">
          <AddFacility isEditMode={true} isReadOnly={true} />
        </div>
      </div>

      <style jsx>{`
        .facility-content {
          padding: 20px;
          background: #fff;
        }
      `}</style>
    </>
  );
};

export default ViewFacilityPage;
